import React, { useContext, useEffect, useState } from "react";
import CryptoJS from "crypto-js";
import { AuthContext } from "../../context/AuthContext";
import Topbar from "../../components/Recruiter/Topbar/Topbar";
import './Adminapproval.css';
import Swal from "sweetalert2";

const AdminApproval = () => {
    const { token } = useContext(AuthContext);
    // const [subscriptionReq, setSubscriptionReq] = useState([{"currentPlanDetails":{"subscription_id":2,"user_email":"sangareswari1234@gmail.com","plan_id":1,"start_date":"2025-03-03T02:57:55.703Z","end_date":"2025-04-03T02:57:55.703Z","is_active":true,"overage_allowed":false,"overage_used":false,"overage_count":0,"created_at":"2025-03-03T08:27:50.239Z","updated_at":"2025-03-03T08:27:50.239Z","plans_id":1,"name":"Free Tier (Trial)","no_of_resumes":200,"no_of_recruiters":100,"no_of_jobs":10,"no_of_cand":0,"no_of_emails":100,"job_ai_usage":0,"email_ai_usage":0,"sms_count":0,"whats_app_count":0,"email_count":0,"overage":false,"duration":{"months":1},"storage_space":"5GB","no_of_jds":100},"upgradePlanDetails":{"plans_id":1,"name":"Free Tier (Trial)","no_of_resumes":200,"no_of_recruiters":100,"no_of_jobs":10,"no_of_cand":0,"no_of_emails":100,"job_ai_usage":0,"email_ai_usage":0,"sms_count":0,"whats_app_count":0,"email_count":0,"overage":false,"duration":{"months":1},"created_at":"2025-03-03T08:27:50.239Z","updated_at":"2025-03-03T08:27:50.239Z","storage_space":"5GB","no_of_jds":100},"overageUsageDetails":[],"usageTrackingDetails":[{"usage_id":1,"user_email":"sangareswari1234@gmail.com","plan_id":1,"action_type":"job","action_count":7,"created_at":"2025-03-03T03:09:55.536Z"},{"usage_id":12,"user_email":"sangareswari1234@gmail.com","plan_id":1,"action_type":"resume","action_count":2,"created_at":"2025-03-05T10:15:38.642Z"}],"companyDetails":{"location":"loc","size":2,"description":"nill","company_id":"192","name":"NIRALS TEST","headquarters":"null","url":"de","industry":"0","lat":null,"lang":null,"about":"null","founded_year":324,"email":"demon@gmail.com","profile":"c213dda808534601846667104.png","specialities":[]},"subscription":{"sid":1,"user_id":280,"plan_id":1,"cid":192,"status":"pending","created_at":"2025-03-07T06:30:22.828Z"}},{"currentPlanDetails":{},"upgradePlanDetails":{"plans_id":3,"name":"Silver","no_of_resumes":10000,"no_of_recruiters":100,"no_of_jobs":200,"no_of_cand":0,"no_of_emails":2500,"job_ai_usage":0,"email_ai_usage":0,"sms_count":0,"whats_app_count":0,"email_count":0,"overage":true,"duration":{"months":1},"created_at":"2025-03-03T08:27:50.239Z","updated_at":"2025-03-03T08:27:50.239Z","storage_space":"50GB","no_of_jds":100},"overageUsageDetails":[],"usageTrackingDetails":[],"companyDetails":{"location":"loc","size":2,"description":"nill","company_id":"194","name":"Nirals","headquarters":"Kovilpatti","url":"www.demo.com","industry":"1","lat":"12.00000000","lang":"12.00000000","about":"This is a Product based company","founded_year":2024,"email":"demo123@gmail.com","profile":"9e238b72ac1c0a4e69f84ef00.png","specialities":["Employee Retention Strategies","recruiting"]},"subscription":{"sid":3,"user_id":300,"plan_id":3,"cid":192,"status":"pending","created_at":"2025-03-08T03:27:25.007Z"}},{"currentPlanDetails":{"subscription_id":2,"user_email":"sangareswari1234@gmail.com","plan_id":1,"start_date":"2025-03-03T02:57:55.703Z","end_date":"2025-04-03T02:57:55.703Z","is_active":true,"overage_allowed":false,"overage_used":false,"overage_count":0,"created_at":"2025-03-03T08:27:50.239Z","updated_at":"2025-03-03T08:27:50.239Z","plans_id":1,"name":"Free Tier (Trial)","no_of_resumes":200,"no_of_recruiters":100,"no_of_jobs":10,"no_of_cand":0,"no_of_emails":100,"job_ai_usage":0,"email_ai_usage":0,"sms_count":0,"whats_app_count":0,"email_count":0,"overage":false,"duration":{"months":1},"storage_space":"5GB","no_of_jds":100},"upgradePlanDetails":{"plans_id":1,"name":"Free Tier (Trial)","no_of_resumes":200,"no_of_recruiters":100,"no_of_jobs":10,"no_of_cand":0,"no_of_emails":100,"job_ai_usage":0,"email_ai_usage":0,"sms_count":0,"whats_app_count":0,"email_count":0,"overage":false,"duration":{"months":1},"created_at":"2025-03-03T08:27:50.239Z","updated_at":"2025-03-03T08:27:50.239Z","storage_space":"5GB","no_of_jds":100},"overageUsageDetails":[],"usageTrackingDetails":[{"usage_id":1,"user_email":"sangareswari1234@gmail.com","plan_id":1,"action_type":"job","action_count":7,"created_at":"2025-03-03T03:09:55.536Z"},{"usage_id":12,"user_email":"sangareswari1234@gmail.com","plan_id":1,"action_type":"resume","action_count":2,"created_at":"2025-03-05T10:15:38.642Z"}],"companyDetails":{"location":"loc","size":2,"description":"nill","company_id":"192","name":"NIRALS TEST","headquarters":"null","url":"de","industry":"0","lat":null,"lang":null,"about":"null","founded_year":324,"email":"demon@gmail.com","profile":"c213dda808534601846667104.png","specialities":[]},"subscription":{"sid":4,"user_id":280,"plan_id":1,"cid":192,"status":"pending","created_at":"2025-03-09T23:42:20.252Z"}}]);
    const [subscriptionReq, setSubscriptionReq] = useState([]);
    const serverURL = process.env.REACT_APP_SERVER_URL;
    const secretKey = process.env.REACT_APP_SECRETKEY;

    const fetchSubscriptions = async () => {
        try {
            const encryptedMetadataAll = localStorage.getItem('metadata');
            const decryptedMetadataAll = JSON.parse(CryptoJS.AES.decrypt(encryptedMetadataAll, secretKey).toString(CryptoJS.enc.Utf8));
            const uid = decryptedMetadataAll.uid;
            const encryptedData = CryptoJS.AES.encrypt(JSON.stringify({ uid }), secretKey).toString();
            
            const response = await fetch(`${serverURL}/subscription/getSubscriptionDetails`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    token: token,
                },
                body: JSON.stringify({ data: encryptedData }),
            });
            
            const data = await response.json();
            const decryptedData = JSON.parse(
                CryptoJS.AES.decrypt(data.data, secretKey).toString(CryptoJS.enc.Utf8)
            );
            
            if (decryptedData) {
                setSubscriptionReq(decryptedData.filteredSubscriptionDetails);
            }
        } catch (error) {
            console.error("Error fetching subscriptions:", error);
        }
    };
    const [showModal, setShowModal] = useState(false);
    const [reason, setReason] = useState(null);
    const [sid, setSid] = useState("");
    const [status, setStatus] = useState("");
    const handleSid = (sid, status) => {
        if(sid != "" && status != ""){
            setSid(sid);
            setStatus(status);
            setShowModal(true);
        }
    };
    const handleCancel = () => {
        setShowModal(false);
        setSid("");
        setStatus("");
        setReason("");
    }
    const approveSubscription = async (sid,status,reason) => {
        let response = "reason";
        if(status === "approve"){
            response = "remark"
        }
        if (reason === null || reason.trim() === "") {
            await Swal.fire({
                title: "Error!",
                text: `Please enter a ${response} to proceed.`,
                icon: "error",
                confirmButtonColor: "#dc3545",
            });
            return;
        }
        setShowModal(false);
        Swal.fire({
            title: "Are you sure?",
            text: `Do you want to ${status} this subscription request?`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#059669",
            cancelButtonColor: "#dc3545",
            confirmButtonText: "Yes",
            cancelButtonText: "No",
        }).then(async(result) => {
            if(result.isConfirmed){
                try {
                    const encryptedData = CryptoJS.AES.encrypt(JSON.stringify({ sid,status,reason }), secretKey).toString();
                    
                    const response = await fetch(`${serverURL}/subscription/upgradeSubscription`, {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            token: token,
                        },
                        body: JSON.stringify({ data: encryptedData }),
                    });
                    
                    if (response.ok) {
                        Swal.fire({
                            title: "Success!",
                            text: `Subscription ${status}d successfully.`,
                            icon: "success",
                            confirmButtonColor: "#059669",
                        }).then(() => {
                            fetchSubscriptions();
                        });
                    } else {
                        Swal.fire({
                            title: "Error!",
                            text: "Something went wrong. Please try again.",
                            icon: "error",
                            confirmButtonColor: "#dc3545",
                        });
                    }
                    
                } catch (error) {
                    console.error("Error approving subscription:", error);
                } finally {
                    setSid("");
                    setStatus("");
                    setReason("");
                }
            }
        })
        setSid("");
        setStatus("");
        setReason("");
    };

    useEffect(() => {
        fetchSubscriptions();
    }, []);

    return (
        <div className="radial-gradient-bg">
            <Topbar />
            {showModal && 
                <div className="reason-modal">
                    <div className="reason-modal-content">
                        <h1>{status === "approve" ? "Remark" : "Enter reason for decline!"}</h1>
                        <textarea
                            className="reason-textarea"
                            placeholder={status === "approve" ? " Enter remark" : "Enter reason"}
                            value={reason}
                            onChange={(e) => setReason(e.target.value)}
                        ></textarea>
                        <div className="flex">
                            <button className="approve-reason" onClick={() => approveSubscription(sid,status,reason)}>Submit</button>
                            <button className="decline-reason" onClick={() => handleCancel()}>Cancel</button>
                        </div>
                    </div>
                </div>
            }
            <div className="subscription-list">
                {subscriptionReq?.length > 0 ? (
                    subscriptionReq.map((req, index) => (
                    <div key={index} className="subscription-card">
                            {req?.subscription?.downgrade && (
                                <span className="mb-2 block bg-red-100 text-red-600 font-semibold text-xs uppercase px-3 py-1 rounded-full shadow-sm">
                                    Downgrade Requested
                                </span>
                            )}
                        <h3>Company: {req.companyDetails.name}</h3>
                        <p><strong>Email:</strong> {req.companyDetails.email}</p>
                        <p><strong>Current Plan:</strong> {req.currentPlanDetails.name}</p>
                        <p><strong>Plan Upgrade Requested:</strong> {req.upgradePlanDetails.name}</p>
                        <p><strong>Status:</strong> {req.subscription.status}</p>
                        <div className="flex">
                        <button onClick={() => handleSid(req.subscription.sid,"approve")}>Approve</button>
                        <button className="decline" onClick={() => handleSid(req.subscription.sid,"decline")}>Decline</button>
                        </div>
                    </div>
                    ))
                ) : (
                    <p className="no-requests">No pending approvals.</p>
                )}
                </div>

        </div>
    );
};

export default AdminApproval;
